import { render, staticRenderFns } from "./SupervisorSelect.vue?vue&type=template&id=e620978e&scoped=true"
import script from "./SupervisorSelect.vue?vue&type=script&lang=js"
export * from "./SupervisorSelect.vue?vue&type=script&lang=js"
import style0 from "./SupervisorSelect.vue?vue&type=style&index=0&id=e620978e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e620978e",
  null
  
)

export default component.exports